"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUpdatePrintableLayerZIndex = exports.UPDATE_Z_INDEX_DIRECTION = exports.UPDATE_PRINTABLE_LAYER_Z_INDEX_PROJECT_ACTION_TYPE = void 0;
const typeguard_1 = require("../types/typeguard");
const ProjectAction_1 = require("./ProjectAction");
exports.UPDATE_PRINTABLE_LAYER_Z_INDEX_PROJECT_ACTION_TYPE = 'UPDATE_PRINTABLE_LAYER_Z_INDEX';
var UPDATE_Z_INDEX_DIRECTION;
(function (UPDATE_Z_INDEX_DIRECTION) {
  UPDATE_Z_INDEX_DIRECTION["FORWARD"] = "forward";
  UPDATE_Z_INDEX_DIRECTION["BACK"] = "back";
})(UPDATE_Z_INDEX_DIRECTION || (exports.UPDATE_Z_INDEX_DIRECTION = UPDATE_Z_INDEX_DIRECTION = {}));
;
const updatePrintableLayerZIndexRuleSet = {
  type: value => value === exports.UPDATE_PRINTABLE_LAYER_Z_INDEX_PROJECT_ACTION_TYPE,
  printableId: typeguard_1.isNonEmptyString,
  layerId: typeguard_1.isNonEmptyString,
  direction: value => value === UPDATE_Z_INDEX_DIRECTION.FORWARD || value === UPDATE_Z_INDEX_DIRECTION.BACK
};
const isUpdatePrintableLayerZIndex = p => {
  return (0, ProjectAction_1.isBaseProjectAction)(p) && (0, typeguard_1.isType)(p, updatePrintableLayerZIndexRuleSet);
};
exports.isUpdatePrintableLayerZIndex = isUpdatePrintableLayerZIndex;